<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-12">
    <h2>
      Rôle
    </h2>
  </div>
</div>

<div class="row m-t-sm">

  <div class="col-sm-9">
    <table class="table table-sm">
      <thead>
      <tr>
        <th>Role</th>
        @if(user.isRoot()) {
          <th>Operation</th>
        }
        <th>Utilisateurs</th>
      </tr>
      </thead>
      @for(role of roles; track role) {
        <tr>
          <td>{{ role.name }}</td>
          @if(user.isRoot()) {
            <td>
              <dl class="list-group">
                @for(op of role.operations; track op) {
                  <dd class="list-group-item">
                    <span>{{ op.name }}</span>
                  </dd>
                }
              </dl>
            </td>
          }
          <td>
            <dl>
              @for(u of role.users; track u) {
                <dd>
                  <a [routerLink]="[u.id]">{{ u.fullname }}</a>
                </dd>
              }
            </dl>
          </td>
        </tr>
      }

    </table>
  </div>
</div>
